import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import styles from "./Toggler.module.css";

/**
 * Interactive component. Switch button (checkbox) that toggles between true and false.
 */
export function Toggler({
  onChange,
  toggled,
  color,
  visible = true,
  readOnly = false,
  disabled = false,
}) {
  return (
    <div style={{ visibility: visible ? "visible" : "hidden" }}>
      <label
        onClick={disabled ? () => {} : onChange}
        htmlFor="toggle"
        // className={classNames(styles.toggler)}
        className={classNames(styles.toggler, { [styles.disabled]: disabled })}
        style={{ backgroundColor: toggled && color }}
      >
        <input
          readOnly={readOnly}
          className={classNames(styles.checkbox)}
          type="checkbox"
          name="toggle"
          value={toggled}
          checked={toggled}
          disabled={disabled}
        />
        {/* <span className={classNames(styles.slider)} /> */}
        <span
          className={classNames(styles.slider, { [styles.disabled]: disabled })}
        />
      </label>
    </div>
  );
}

Toggler.propTypes = {
  /**
   * Function that fires when the toggle is clicked.
   */
  onChange: PropTypes.func,
  /**
   * Boolean that determines if the toggler is toggled or not.
   */
  toggled: PropTypes.bool,
  /**
   * String that determines the background color when the toggled prop is true.
   */
  color: PropTypes.string,
};
